module.exports = __webpack_public_path__ + "media/9.c6f782e3.mp3";